<ng-container *transloco="let t">
  <div class="mx-8">
    <p>{{ t("move-strategy-asins-modal.move_asin_to", [prettyPrintAsins(modalData.asinsToMove)]) }}</p>
    <div class="row mx-2 w-64">
      <ISelectMenu
        class="w-full"
        [value]="target()"
        (valueChange)="selectStrategy($event)"
        [(searchQuery)]="searchQuery"
        fitTriggerWidth
      >
        <ISelectTrigger class="flex w-full">
          <ISelectValue [placeholder]="t('move-strategy-asins-modal.select_a_strategy')">
            <div *iSelectValue="let value" class="flex items-center gap-2 truncate">
              @if (value !== NEW_STRATEGY) {
                <app-strategy-state [state]="value.state"></app-strategy-state>
                <span class="truncate text-sm">{{ value.name }}</span>
              } @else {
                <span class="truncate text-sm">New strategy</span>
              }
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [value]="NEW_STRATEGY">
            <span class="truncate text-sm">New strategy</span>
          </ISelectOption>
          @for (strategy of filteredStrategies(); track strategy.strategyId) {
            <ISelectOption [value]="strategy">
              <div class="flex items-center gap-2 truncate">
                <app-strategy-state [state]="strategy.state"></app-strategy-state>
                <span class="truncate text-sm">{{ strategy.name }}</span>
              </div>
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
  </div>
  <div class="mt-4 flex justify-end gap-2">
    <button iButton variant="ghost" (click)="modalRef.close()">
      {{ t("common.cancel") }}
    </button>
    <button iButton (click)="confirm()">
      {{ t("common.confirm") }}
    </button>
  </div>
</ng-container>
